import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { Warning as WarningIcon, ArrowForward } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import styles from './IntegrationBanner.module.scss';

const IntegrationBanner = ({ isCompleted, shopId }) => {
  const history = useHistory();
  const localizeMessage = useLocalizedMessage();

  if (isCompleted) return null;

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <WarningIcon fontSize="large" />
        </div>
        <div className={styles.text}>
          <h3>{localizeMessage('cloud.home.integration.title')}</h3>
          <p>{localizeMessage('cloud.home.integration.description')}</p>
        </div>
      </div>
      <div className={styles.action}>
        <Button
          variant="contained"
          style={{ backgroundColor: '#ef6c00', color: 'white' }}
          endIcon={<ArrowForward />}
          onClick={() => history.push(`/app/${shopId}/search/setup`)}
        >
          {localizeMessage('cloud.home.integration.resume')}
        </Button>
      </div>
    </div>
  );
};

IntegrationBanner.propTypes = {
  isCompleted: PropTypes.bool.isRequired,
  shopId: PropTypes.string.isRequired,
};

export default IntegrationBanner;
